"use client";

import { Toaster as Sonner } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
	return (
		<Sonner
			// 全站 light；"system" 会让深色手机弹出黑底 toast 压在白页面上
			theme="light"
			className="toaster group"
			toastOptions={{
				classNames: {
					toast: "group toast !rounded-lg !font-sans group-[.toaster]:bg-card group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-md !py-3 !px-4 !min-w-0 !max-w-[360px] !min-h-[56px]",
					description:
						"group-[.toast]:text-muted-foreground !text-sm !mt-1",
					actionButton:
						"group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
					cancelButton:
						"group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
					success: "!text-success",
					error: "!text-destructive !border-destructive",
					title: "!m-0 !p-0 !leading-relaxed",
					content: "!flex !items-center !gap-3",
					icon: "!m-0 !flex !items-center !justify-center",
				},
				duration: 5000,
			}}
			{...props}
		/>
	);
};

export { Toaster };
